module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blank"
  }, [(_vm.isDd) ? _c('div', {}, [_c('div', {
    staticClass: "help-header"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _c('li', [_c('a', {
    ref: "kfPhone",
    on: {
      "click": _vm.kfPhoneHandle
    }
  }, [_c('i'), _vm._v(" "), _c('p', [_vm._v("客服热线")])])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "h-title"
  }, [_vm._v("常见问题分类")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "help-list"
  }, [_c('group', {
    attrs: {
      "gutter": "0",
      "type": "hint"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('cell', {
      key: index,
      staticClass: "help",
      attrs: {
        "title": item.categoryName
      },
      on: {
        "click": function($event) {
          return _vm.nextRoute(index)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "right"
      },
      slot: "right"
    }, [_c('img', {
      staticClass: "icon",
      attrs: {
        "src": require("../assets/images/link.png"),
        "height": "12",
        "width": "7",
        "alt": ""
      }
    })])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAlert),
      expression: "isAlert"
    }],
    staticClass: "alert-def-ui"
  }, [_c('div', {
    staticClass: "alert-box"
  }, [_c('div', {
    staticClass: "alert-content"
  }, [_vm._v("\n                拨打点点客服热线：4000666122，服务时间：周一到周日 9:00-18:00。\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "alert-btn",
    on: {
      "click": _vm.alertBtnHandle
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://im2.zhongan.io/zaim/?accessId=1585100918028&tenantID=1557976036000381&color=yellow&themeID=DD001&subject=点点业务&biz=APP"
    }
  }, [_c('i'), _vm._v(" "), _c('p', [_vm._v("在线客服")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "zldd://feedBack"
    }
  }, [_c('i'), _vm._v(" "), _c('p', [_vm._v("意见反馈")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e481fe2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/helpcenter.vue
// module id = 202
// module chunks = 0